module.exports = __webpack_public_path__ + "media/packs/site/assets/images/combook_binding/cover_generator_manual/step4-d6ddb5f6fe4b4a5d47ab170b7d467abf.png";